import { utils } from '@deeptrue-frontend/ui';
import React from 'react';
import {
  localization,
  PropertyGridEditorCollection,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from 'survey-react-ui';
import ReactDOMServer from 'react-dom/server';
import { ReactComponent as WidgetIcon } from 'assets/icons/widget.svg';

import { ElementFactory, Question, Serializer, SvgRegistry } from 'survey-core';

export const registerAssetUpload = () => {
  const AssetUpload = utils.survey.widgets.AssetUpload.widget;

  class QuestionAssetuploadModel extends Question {
    getType() {
      return 'dtassetuploadv2';
    }
    get assetuploadType() {
      return this.getPropertyValue('assetuploadType');
    }
    set assetuploadType(val) {
      this.setPropertyValue('assetuploadType', val);
    }
  }

  // set display title for question type
  localization.getLocale('').qt.dtassetuploadv2 = 'dt Asset Upload';

  const svg = ReactDOMServer.renderToString(<WidgetIcon />);
  SvgRegistry.registerIconFromSvg('dtassetuploadv2', svg);

  // this serializes the class into JSON
  Serializer.addClass(
    'dtassetuploadv2',
    [
      {
        name: 'assetuploadType',
      },
    ],
    function () {
      return new QuestionAssetuploadModel('');
    },
    'question'
  );

  SurveyQuestionEditorDefinition.definition.dtassetuploadv2 = {
    properties: [{ name: 'assetuploadType', tab: 'layout' }],
  };

  ElementFactory.Instance.registerElement('dtassetuploadv2', (name) => {
    return new QuestionAssetuploadModel(name);
  });

  class SurveyQuestionAssetupload extends SurveyQuestionElementBase {
    constructor(props: any) {
      super(props);
      this.state = { value: this.question.value };
    }
    get question() {
      return this.questionBase;
    }
    get value() {
      return this.question.value;
    }

    get type() {
      // @ts-ignore KRZYŚ
      return this.question.assetuploadType;
    }
    handleAssetuploadChange = (data: any) => {
      this.question.value = data;
    };

    // support readOnly and designMode
    get style() {
      return this.question.getPropertyValue('readOnly') ||
        this.question.isDesignMode
        ? {
            pointerEvents: 'none',
          }
        : undefined;
    }

    renderElement() {
      return <AssetUpload question={this.question} />;
    }
  }
  ReactQuestionFactory.Instance.registerQuestion(
    'dtassetuploadv2',
    (props: any) => {
      return React.createElement(SurveyQuestionAssetupload, props);
    }
  );

  Serializer.addProperties('dtassetuploadv2', [
    {
      name: 'localeExpression:expression',
      category: 'Language consumer',
    },
    {
      name: 'addLinkText:string',
      default: 'Add Video Link',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'chooseFileText:string',
      default: 'Add File',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'imageType:boolean',
      default: true,
      category: 'Asset types',
    },
    {
      name: 'videoType:boolean',
      default: true,
      category: 'Asset types',
    },
    {
      name: 'pdfType:boolean',
      default: true,
      category: 'Asset types',
    },
    {
      name: 'titleText:string',
      default: 'Advertisment Material',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'errMesageText:string',
      default: 'Error, please try again',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'errMesageValidationText:string',
      default: 'Please upload advertising material',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'supportedFilesText:string',
      default: 'You can add ',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'filesText:string',
      default: ' files',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'videoLinkText',
      default: 'video link',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'modalTitleText:string',
      default: 'Add a Link',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'modalDescriptionText:string',
      default: 'Add a link for advertising material.',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'modalCancelText:string',
      default: 'Cancel',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'embedError:string',
      default: 'Error while embeding url',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'modalSaveText:string',
      default: 'Save Link',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'isRequiredErrorText:string',
      default: 'Please upload assets for all supported languages',
      category: 'Locales',
      isLocalizable: true,
    },
    {
      name: 'supportedAssetType',
      default: ['image/*'],
      dependsOn: ['imageType', 'videoType', 'pdfType'],
      visible: false,
      category: 'Asset types',
      onGetValue: function (obj: any) {
        const types: string[] = [];

        if (obj.imageType)
          types.push('image/jpeg', 'image/gif', 'image/svg+xml', 'image/png');
        if (obj.videoType) types.push('video/mpeg', 'video/mp4');
        if (obj.pdfType) types.push('application/pdf');

        return types;
      },
    },
  ]);

  PropertyGridEditorCollection.register({
    fit: function (prop: { type: string }) {
      return prop.type === 'dtassetuploadv2';
    },
    getJSON: function () {
      return { type: 'dtassetuploadv2' };
    },
  });
};
